import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import ListSeller from "../DadosCadastrais/ListSeller";
import {
  empresasSeller,
  gerarExelSellers,
  empresasSellerComFiltro,
} from "../../../../services/http/sellerService";
import { trackPromise } from "react-promise-tracker";
import { useSnackBar } from "../../../../hooks/snackBar";
import { saveAs } from "file-saver";
import FormControl from "@material-ui/core/FormControl";
import InputSearch from "../../../../components/InputSearch";

import "./styles.scss";
import { set } from "../../../../services/storage";

const Seller = () => {
  const { addSnackBar } = useSnackBar();
  const history = useHistory();
  const [busca, setBusca] = useState("");
  const [empresaResponse, setEmpresas] = useState({
    numeroPagina: 0,
    totalPaginas: 0,
    lista: [],
    tamanhoPagina: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  const CarregarListaSellers = (pagina) => {
    trackPromise(
      empresasSeller(pagina).then((res) => {
        if (res.data) {
          setEmpresas(res.data);
        } else {
          addSnackBar({
            message: "Não foi possível carregar sellers",
            info: "error",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar carregar sellers",
        info: "error",
        open: true,
      });
    });
  };

  const CarregarListaSellersComFiltro = (filtro, pagina) => {
    trackPromise(
      empresasSellerComFiltro(filtro, pagina).then((res) => {
        if (res.data) {
          setEmpresas(res.data);
        } else {
          addSnackBar({
            message: "Não foi possível carregar sellers",
            info: "error",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar carregar sellers",
        info: "error",
        open: true,
      });
    });
  };

  const extrairBase = () => {
    trackPromise(
      gerarExelSellers().then((res) => {
        if (res.data) {
          saveAs(res.data, "sellers.xlsx");
        } else {
          addSnackBar({
            message: "Não foi possível extrair a base com sellers",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano extrair a base com sellers",
        info: "error",
        open: true,
      });
    });
  };

  const mudarPaginaSeller = (page) => {
    busca != ""
      ? CarregarListaSellersComFiltro(busca, page)
      : CarregarListaSellers(page);
  };

  const buscar = (filtro) => {
    setBusca(filtro);
  };

  useEffect(() => {
    if (busca != "") {
      const delayDebounceFn = setTimeout(() => {
        CarregarListaSellersComFiltro(busca, 1);
      }, 2000);

      return () => clearTimeout(delayDebounceFn);
    } else {
      CarregarListaSellers(1);
    }
  }, [busca]);

  useEffect(() => {
    CarregarListaSellers(1);
  }, []);

  return (
    <div className="sellers-container">
      <div className="row mb-3">
        <div className="col-12">
          <h2 className="titulo">Sellers</h2>
        </div>
      </div>

      {/* Botões de ação */}
      <div className="row">
        <div className="col-sm-6 col-md-3 mb-2">
          <button
            className="button-anexar buton-green w-100"
            onClick={() => history.push(`/admin/seller/cadastro`)}
          >
            NOVO SELLER
          </button>
        </div>
        <div className="col-sm-6 col-md-3 mb-2">
          <button
            className="buton-white-black-border btn btn-block btn-lg"
            onClick={extrairBase}
          >
            EXTRAIR BASE
          </button>
        </div>
      </div>

      {/* Campo de busca */}
      <div className="row mb-1 d-flex justify-content-end">
        <div className="col-sm-6 col-md-3">
          <FormControl>
            <InputSearch buscar={buscar} buscaPor={busca} />
          </FormControl>
        </div>
      </div>

      {/* Lista de sellers */}
      <div className="row">
        <div className="col-12">
          <ListSeller
            response={empresaResponse}
            mudarPagina={mudarPaginaSeller}
            buscar={buscar}
            busca={busca}
          />
        </div>
      </div>
    </div>
  );
};

export default Seller;
